import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/PreAdvise/createPreAdviceDetails.css';
import SuccessModal from '../../Shared/SuccessModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class CreatePreAdviseDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            carrier: "Carrier O/B Declared",
            portLoad: "Port of Load",
            portDischarge: "Port of Discharge",
            freight: "Freight Kind",
            hasOpen: false,
        }
    }
    submitContainer = () => {
        this.setState({ hasOpen: true });
    }
    OnAddReefer = () => {
        this.props.history.push('/AddReefer')
    }
    OnAddHazard = () => {
        this.props.history.push('/AddHazard')
    }
    OnAddOOG = () => {
        this.props.history.push('/OOGDetails')
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/PreAdvise', {})
    };
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.createPreAdviseDetailsPageTitle} description={TitleDescription.createPreAdviseDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofull123">
                    <div id="csnobox121">
                        <nav class="ccnononavbar111">
                            <div className="ccnonavbarnamePreDetails">
                                <small id="nonavc123"> Pre-advise for Single Container</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincardcreate">
                            <div class="consdiv1precreate">
                                <div class="consdiv3create">
                                    <div class="cardleft123">
                                        <div class="cardleft11precreate">
                                            <small id="carrier">Carrier O/B Declared</small>
                                            <small id="carriervalue">{this.state.carrier}</small>
                                        </div>
                                    </div>
                                    <div class="cardleft2precreate">
                                        <div class="cardleft21precreate">
                                            <small id="carrier">Port of Load</small>
                                            <small id="carriervalue">{this.state.portLoad}</small>
                                        </div>
                                    </div>
                                    <div class="cardleft3precreate">
                                        <small id="carrier">Port of Discharge</small>
                                        <small id="carriervalue">{this.state.portDischarge}</small>
                                    </div>
                                </div>
                                <div class="upperlowerdiv">
                                    <div class="cardleft1232">
                                        <div class="cardleft12precreate">
                                            <small id="carrier">Freight Kind</small>
                                            <small id="carriervalue">{this.state.freight}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="belowcard">
                                <div class="reefer" onClick={this.OnAddReefer}>
                                    <small id="redreefer">Add Reefer</small>
                                </div>
                                <div class="hazard" onClick={this.OnAddHazard}>
                                    <small id="redreefer">Add Hazard</small>
                                </div>
                                <div class="OOG" onClick={this.OnAddOOG}>
                                    <small id="redreefer">Add OOG</small>
                                </div>
                            </div>
                            <div class="submitttouter">
                                <div class="submitbttn">
                                    <Button class="bttcreate" onClick={this.submitContainer}>
                                        <small id="createsubmit"> Submit</small>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="successtext1createpreadvise">Your request for Pre-advise </small>
                            <small class="successtext1createpreadvise"> has been submitted successfully</small>
                        </div>
                    </div>
                </SuccessModal>
            </div>
        );
    }
}
export default CreatePreAdviseDetails;